import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["trigger", "tooltip", "arrow", "popup", "overlay"]

  connect() {}

  showTooltip() {
    if (!this.hasTooltipTarget) return
    
    const trigger = this.triggerTarget
    const tooltip = this.tooltipTarget
    const arrow = this.hasArrowTarget ? this.arrowTarget : null
    
    this.positionTooltip(trigger, tooltip, arrow)
    
    tooltip.classList.remove("hidden")
    tooltip.classList.add("opacity-100")
  }

  hideTooltip() {
    if (!this.hasTooltipTarget) return
    
    this.tooltipTarget.classList.add("hidden")
    this.tooltipTarget.classList.remove("opacity-100")
  }

  positionTooltip(trigger, tooltip, arrow) {
    const position = tooltip.getAttribute("data-position") || "top"
    const triggerRect = trigger.getBoundingClientRect()
    const tooltipRect = tooltip.getBoundingClientRect()
    
    let top, left
    
    switch (position) {
      case "top":
        top = triggerRect.top - tooltipRect.height - 10
        left = triggerRect.left + (triggerRect.width / 2) - (tooltipRect.width / 2)
        break
      case "bottom":
        top = triggerRect.bottom + 10
        left = triggerRect.left + (triggerRect.width / 2) - (tooltipRect.width / 2)
        break
      case "left":
        top = triggerRect.top + (triggerRect.height / 2) - (tooltipRect.height / 2)
        left = triggerRect.left - tooltipRect.width - 10
        break
      case "right":
        top = triggerRect.top + (triggerRect.height / 2) - (tooltipRect.height / 2)
        left = triggerRect.right + 10
        break
    }
    
    // Constrain to viewport
    const viewport = {
      width: window.innerWidth,
      height: window.innerHeight
    }
    
    // Adjust horizontal position if necessary
    if (left < 10) left = 10
    if (left + tooltipRect.width > viewport.width - 10) 
      left = viewport.width - tooltipRect.width - 10
    
    // Adjust vertical position if necessary
    if (top < 10) top = 10
    if (top + tooltipRect.height > viewport.height - 10) 
      top = viewport.height - tooltipRect.height - 10
    
    // Set position
    tooltip.style.top = `${top}px`
    tooltip.style.left = `${left}px`
    
    // Position arrow
    if (arrow) {
      switch (position) {
        case "top":
          arrow.style.bottom = "-5px"
          arrow.style.left = "50%"
          arrow.style.transform = "translateX(-50%) rotate(45deg)"
          break
        case "bottom":
          arrow.style.top = "-5px"
          arrow.style.left = "50%"
          arrow.style.transform = "translateX(-50%) rotate(45deg)"
          break
        case "left":
          arrow.style.right = "-5px"
          arrow.style.top = "50%"
          arrow.style.transform = "translateY(-50%) rotate(45deg)"
          break
        case "right":
          arrow.style.left = "-5px"
          arrow.style.top = "50%"
          arrow.style.transform = "translateY(-50%) rotate(45deg)"
          break
      }
    }
  }

  togglePopup() {
    if (!this.hasPopupTarget) return
    
    if (this.popupTarget.classList.contains("hidden")) {
      this.showPopup()
    } else {
      this.hidePopup()
    }
  }

  showPopup() {
    if (!this.hasPopupTarget) return
    
    this.popupTarget.classList.remove("hidden")
    this.overlayTarget.classList.remove("hidden")
    
    // Prevent body from scrolling
    document.body.style.overflow = "hidden"
    
    // Animate in
    setTimeout(() => {
      this.overlayTarget.classList.add("opacity-100")
      this.popupTarget.classList.add("opacity-100")
    }, 10)
  }

  hidePopup() {
    if (!this.hasPopupTarget) return
    
    this.popupTarget.classList.remove("opacity-100")
    this.overlayTarget.classList.remove("opacity-100")
    
    // Allow body to scroll again
    document.body.style.overflow = ""
    
    // Hide after transition
    setTimeout(() => {
      this.popupTarget.classList.add("hidden")
      this.overlayTarget.classList.add("hidden")
    }, 300)
  }
}
